export const numberFormatterDecimal = (value) => {
    return (value && value % 1 > 0) ? parseFloat((Math.round(value * 100) / 100).toFixed(2)).toLocaleString() : parseFloat((Math.round(value * 100) / 100).toFixed(2)).toLocaleString() + '.00'
};